import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {BatchPdfOption} from '../../../shared/export/export';
import {getOppositeNodeExpansionState, nodeExpansionIsActive} from '../../../shared/helpers';
import {selectMandatoryChildren, selectOrDeselectParents} from '../../../export-dialog-multilevel/export-dialog-helper';
import {BenchmarkOption, NodeExpansionState} from '../../../shared/enums';
import {MetricType} from '../../../shared/metric-types';
import {BenchmarkType} from '../../../shared/benchmark-types';
import {BatchExportMetricSection, batchExportMetricSectionHasAnOptionSelected} from '../../batch-export-helper';

@Component({
  selector: 'app-batch-dialog-hierarchical-selector',
  templateUrl: './batch-dialog-hierarchical-selector.component.html',
  styleUrls: ['./batch-dialog-hierarchical-selector.component.scss']
})
export class BatchDialogHierarchicalSelectorComponent implements OnChanges {
  @Input() hierarchyOptions: BatchPdfOption[];
  @Input() topOptions: BatchPdfOption[] = [];
  @Input() isFirstOption: boolean;
  @Input() canShowBenchmarkSelector = false;
  @Input() whenHierarchicalOptionSelected: () => void;
  @Input() batchExportMetricSection?: BatchExportMetricSection;
  @Output() whenBenchmarkOptionChosen = new EventEmitter<BenchmarkOption>();
  @Output() whenPercentileChosen = new EventEmitter<BenchmarkType>();
  displayedHierarchyOptions: BatchPdfOption[];
  hoverMessage: string | undefined;

  readonly nodeExpansionIsActive = nodeExpansionIsActive;
  readonly MetricType = MetricType;
  readonly NodeExpansionState = NodeExpansionState;

  constructor() { }
  ngOnChanges(): void {
    this.displayedHierarchyOptions = this.hierarchyOptions.filter(o => o.displayed);
  }

  whenOptionSelected(option: BatchPdfOption): void {
    option.selected = !option.selected;
    this.selectOrDeselectChildren(option);
    selectOrDeselectParents(this.topOptions);
    selectMandatoryChildren(this.topOptions, this.topOptions[0].selected);
    if (this.batchExportMetricSection) {
      this.batchExportMetricSection.selected = option.selected || batchExportMetricSectionHasAnOptionSelected(
        this.batchExportMetricSection.options);
    }
    this.whenHierarchicalOptionSelected();
  }

  private selectOrDeselectChildren(option: BatchPdfOption): void {
    option.children.forEach((child: BatchPdfOption) => {
      child.selected = option.selected;
      this.selectOrDeselectChildren(child);
    });
  }

  whenOptionExpanded(option: BatchPdfOption): void {
    option.nodeExpansionState = getOppositeNodeExpansionState(option.nodeExpansionState);
  }

  chooseBenchmarkOption(benchmarkOption: BenchmarkOption): void {
    this.whenBenchmarkOptionChosen.emit(benchmarkOption);
  }

  choosePercentile(percentile: BenchmarkType): void {
    this.whenPercentileChosen.emit(percentile);
  }
}
